module.exports = __webpack_public_path__ + "static/media/garmin-logo-badge.19e79e3a.svg";